<template>
	<div class="ReInputMask">
		<input v-if="mask=='phone'"
          v-model.lazy="currentValue"
          class="form-control input-phone"
          aria-describedby="addon-right addon-left"
		  :placeholder="placeholder"
		  :id="mask"
		  v-bind="$attrs"
          v-cleave="{phone:true, phoneRegionCode: 'RU'}"
        />
		<input v-if="mask=='money'"
          v-model.lazy="currentValue"
          class="form-control"
          aria-describedby="addon-right addon-left"
		  :placeholder="placeholder"
		  :id="mask"
		  v-bind="$attrs"
          v-cleave="{numeral:true, numeralPositiveOnly: positiveOnly, numeralThousandsGroupStyle: 'thousand',numeralDecimalMark: ',', delimiter: ' ',}"
        />
	</div>
</template>

<script>
	import Cleave from 'cleave.js';
	import cleavePhoneI18n from 'cleave.js/dist/addons/cleave-phone.i18n';
	export default {
		name: 'ReInputMask',
		components: {
			// Cleave,
		},
		props: {
			value: {
				type: [String, Number],
				default: '',
			},
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
			placeholder: {
				type: String,
				default: '',
			},
			mask: {
				type: String,
				default: '',
			},
			positiveOnly: {
				type: Boolean,
				default: true,
			},
			// numericOnly:{
			// 	type: Boolean,
			// 	default: false,
			// }
			
		},
		data () {
			return {
				ver: 1,
				// bufferValue: this.value,
				currentValue: this.value,
			}
		},
		watch:{
			value(val){
				// this.currentValue = this.$GVO.unlinkObject(val);
				if(val == ''){this.currentValue=''}
				// this.currentValue = val;
			},
			// bufferValue(val){
			// 	this.bufferValue = val;
			// 	this.$emit("input", this.bufferValue);
			// 	// this.$emit(`#${mask}`, this.bufferValue); // for hidden input, doesn't work
			// },
		},
		computed: {

		},
		methods: {
			onValueChanged({ target }) {
				this.$nextTick(() => {
					this.currentValue = target.value;
					this.$emit('input', target.rawValue);
				});
			},

		},
		directives: {
			cleave: {
				// inserted: (el, binding) => {
				// 	el.cleave = new Cleave(el, binding.value || {});
				// },
				// update: (el) => {
				// 	const event = new Event("input", {bubbles: true,/**/});
				// 	setTimeout(function () {
				// 		// console.log( el.cleave.properties);
				// 		el.value = el.cleave.properties.result;		
				// 		el.dispatchEvent(event);
				// 	}, 100);
				// }
				
			}
		},
		
		mounted() {			
			// this.bufferValue = this.value;
			if(this.mask=='money') {
				this.cleave = new Cleave(this.$el.querySelector('input'), {
					numeral: true,		
					numeralPositiveOnly: this.positiveOnly,	
					// numericOnly: this.numericOnly, // если что эта шутка в состоянии true сделает ввод только для целых чисел
					numeralThousandsGroupStyle: 'thousand',
					numeralDecimalMark: ',', 
					delimiter: ' ',					
					onValueChanged: this.onValueChanged.bind(this),
				});
				this.cleave.setRawValue(this.value);
			}
			if(this.mask=='phone') {
				this.cleave = new Cleave(this.$el.querySelector('input'), {
					phone:true, 
					phoneRegionCode: 'RU',					
					onValueChanged: this.onValueChanged.bind(this),
				});
				this.cleave.setRawValue(this.value);
			}

			
		}
	}
</script>
<style scoped>

</style>
